import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwwarurbaniaonrent() {



  const cardData = {
"keyword": "Pune to Mahabaleshwar Urbania On Rent",

"headingDescription":
  "Aaradhya Travels offers premium Pune to Mahabaleshwar Urbania on Rent for family trips, corporate outings, weddings, group tours, and weekend getaways. Our Force Urbania vehicles provide a luxury travel experience with spacious pushback seating, powerful air-conditioning, smooth suspension for ghat roads, LED lighting, charging points, and ample luggage space. With experienced drivers and well-maintained vehicles, we ensure a safe, comfortable, and hassle-free journey from Pune to Mahabaleshwar for all group sizes.",

"topPlaces": [
  {
    "title": "Venna Lake",
    "description":
      "Venna Lake is one of Mahabaleshwar’s most popular attractions known for boating, horse riding, and scenic views. It is a must-visit leisure spot for families and groups traveling from Pune in luxury Urbania vans."
  },
  {
    "title": "Pratapgad Fort",
    "description":
      "Pratapgad Fort is a historic Maratha fort known for its connection with Chhatrapati Shivaji Maharaj and offers panoramic views of the Sahyadri mountains, making it a key sightseeing stop."
  },
  {
    "title": "Mapro Garden",
    "description":
      "Mapro Garden is famous for strawberries, fresh food products, chocolate, and scenic garden spaces. It is a popular stop for food breaks and group sightseeing tours."
  },
  {
    "title": "Arthur’s Seat",
    "description":
      "Arthur’s Seat is a famous viewpoint offering stunning views of valleys and cliffs. It is one of the most scenic points in Mahabaleshwar and a highlight of hill station tours."
  },
  {
    "title": "Elephant’s Head Point",
    "description":
      "Elephant’s Head Point is known for its unique rock formation resembling an elephant’s head and offers breathtaking valley views, perfect for photography and group visits."
  },
  {
    "title": "Lingmala Waterfall",
    "description":
      "Lingmala Waterfall is a beautiful seasonal waterfall surrounded by greenery and is a popular attraction for nature lovers visiting Mahabaleshwar."
  },
  {
    "title": "Wilson Point",
    "description":
      "Wilson Point is the highest point in Mahabaleshwar and is famous for sunrise views, making it a must-visit for early morning sightseeing tours."
  },
  {
    "title": "Panchgani Table Land",
    "description":
      "Panchgani Table Land is a vast volcanic plateau offering scenic views and horse riding activities, often included in combined Mahabaleshwar–Panchgani tours."
  },
  {
    "title": "Sydney Point",
    "description":
      "Sydney Point in Panchgani offers beautiful views of Krishna Valley and Dhom Dam, making it a peaceful stop during hill station trips."
  },
  {
    "title": "Kates Point",
    "description":
      "Kates Point is a scenic viewpoint known for its cliffside views and photography spots, ideal for group sightseeing during Mahabaleshwar travel."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description":
      "Tapola is known as Mini Kashmir for its lake, boating activities, and peaceful natural surroundings, perfect for leisure stops during luxury group tours."
  },
  {
    "title": "Old Mahabaleshwar Temple",
    "description":
      "The Old Mahabaleshwar Temple is a sacred Shiva temple and an important spiritual site included in many pilgrimage and family tours."
  },
  {
    "title": "Connaught Peak",
    "description":
      "Connaught Peak offers panoramic views of valleys and Venna Lake and is a peaceful viewpoint for sightseeing groups visiting Mahabaleshwar."
  },
  {
    "title": "Krishnabai Temple",
    "description":
      "Krishnabai Temple is a serene religious site known for its peaceful surroundings and spiritual importance near Mahabaleshwar."
  },
  {
    "title": "Babington Point",
    "description":
      "Babington Point is a scenic viewpoint surrounded by forests and valleys, offering a quiet and less crowded sightseeing experience."
  },
  {
    "title": "Elphinstone Point",
    "description":
      "Elphinstone Point is a dramatic viewpoint offering deep valley views and misty landscapes, ideal for nature lovers and photographers."
  },
  {
    "title": "Falkland Point",
    "description":
      "Falkland Point is a lesser-known viewpoint offering peaceful surroundings and scenic valley views, perfect for relaxed group travel stops."
  },
  {
    "title": "Kate’s Sunset Point",
    "description":
      "Kate’s Sunset Point is famous for sunset views over valleys and hills, making it a romantic and scenic stop during Mahabaleshwar trips."
  },
  {
    "title": "Strawberry Farms",
    "description":
      "Mahabaleshwar strawberry farms are a major attraction where visitors can enjoy fresh strawberries, cream, and farm experiences during seasonal visits."
  },
  {
    "title": "Dhom Dam",
    "description":
      "Dhom Dam near Wai offers scenic water views and is often included in Pune to Mahabaleshwar route sightseeing stops for group travelers."
  }
],



services: [
  {
    name: "Pune to Mahabaleshwar Urbania On Rent",
    description: "Pune to Mahabaleshwar Urbania on rent service provides luxurious transportation for hill station vacations, sightseeing tours, family trips, and weekend getaways from Pune. Spacious seating and smooth ghat road travel ensure comfortable journeys suitable for tourist and family groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Mahabaleshwar route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar Urbania reservations."
  },
  {
    name: "Pune to Panchgani Urbania On Rent",
    description: "Pune to Panchgani Urbania on rent service offers premium transportation for sightseeing journeys, educational tours, family vacations, and tourist travel from Pune. Spacious interiors and comfortable seating ensure smooth hill station travel suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Panchgani Urbania reservations."
  },
  {
    name: "Pune to Tapola Urbania on Rent",
    description: "Pune to Tapola Urbania on rent service provides dependable premium transportation for lakeside tourism, camping trips, sightseeing journeys, and family vacations from Pune. Spacious luxury interiors and smooth highway travel ensure pleasant journeys suitable for tourist and adventure groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Tapola Urbania reservations."
  },
  {
    name: "Pune to Wai Satara Urbania on Rent",
    description: "Pune to Wai Satara Urbania on rent service offers comfortable transportation for temple visits, sightseeing tours, educational trips, and family travel from Pune. Spacious seating and luggage space ensure smooth highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Wai Satara Urbania reservations."
  },
  {
    name: "Pune to Kolhapur Urbania on Rent",
    description: "Pune to Kolhapur Urbania on rent service provides luxurious transportation for Mahalaxmi temple visits, business travel, family vacations, and sightseeing tours from Pune. Spacious seating and modern interiors ensure comfortable long-distance travel suitable for tourist and pilgrimage groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Kolhapur Urbania reservations."
  },
  {
    name: "Pune to Jyotiba Urbania on Rent",
    description: "Pune to Jyotiba Urbania on rent service offers premium transportation for temple darshan tours, spiritual journeys, and pilgrimage travel from Pune. Spacious seating and smooth highway performance ensure comfortable travel experiences suitable for devotees and family groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotiba Urbania reservations."
  },
  {
    name: "Pune to Kaas Plateau Urbania on Rent",
    description: "Pune to Kaas Plateau Urbania on rent service provides comfortable transportation for sightseeing tours, nature photography trips, family vacations, and eco-tourism travel from Pune. Spacious interiors and smooth ghat road travel ensure pleasant journeys suitable for tourist and nature lover groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Kaas Plateau Urbania reservations."
  },
  {
    name: "Pune to Lonavala Urbania on Rent",
    description: "Pune to Lonavala Urbania on rent service offers premium transportation for weekend trips, sightseeing tours, office outings, and family vacations from Pune. Spacious seating and smooth expressway travel ensure comfortable journeys suitable for tourist and corporate groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Lonavala Urbania reservations."
  },
  {
    name: "Pune to Matheran Urbania on Rent",
    description: "Pune to Matheran Urbania on rent service provides luxurious transportation for hill station vacations, sightseeing tours, and family trips from Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for tourist and family groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Matheran Urbania reservations."
  },
  {
    name: "Pune to Igatpuri Urbania on Rent",
    description: "Pune to Igatpuri Urbania on rent service offers comfortable transportation for meditation retreats, hill station travel, sightseeing tours, and family vacations from Pune. Spacious luxury interiors and luggage space ensure smooth highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Igatpuri Urbania reservations."
  },
  {
    name: "Pune to Nashik Urbania on Rent",
    description: "Pune to Nashik Urbania on rent service provides premium transportation for pilgrimage tours, wine tourism, sightseeing journeys, and family travel from Pune. Spacious seating and comfortable interiors ensure smooth long-distance journeys suitable for tourist and business groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Nashik Urbania reservations."
  },
  {
    name: "Pune to Shirdi Urbania on Rent",
    description: "Pune to Shirdi Urbania on rent service offers dependable premium transportation for Sai Baba darshan tours, pilgrimage journeys, and spiritual group travel from Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi Urbania reservations."
  },
  {
    name: "Pune to Bhimashankar Urbania on Rent",
    description: "Pune to Bhimashankar Urbania on rent service provides comfortable transportation for Jyotirlinga darshan tours, spiritual journeys, sightseeing trips, and pilgrimage travel from Pune. Spacious interiors and smooth ghat road travel ensure pleasant experiences suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Bhimashankar Urbania reservations."
  },
  {
    name: "Urbania for Outstation Pune",
    description: "Urbania for outstation Pune service offers premium long-distance transportation for Goa trips, Konkan Darshan, Mahabaleshwar tours, pilgrimage journeys, and family vacations. Spacious luxury seating and luggage capacity ensure comfortable highway travel suitable for tourist and business groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Urbania for Family Trip Pune",
    description: "Urbania for family trip Pune service provides luxurious transportation for holiday vacations, sightseeing journeys, pilgrimage tours, and group travel with relatives and family members. Spacious seating and smooth travel performance ensure comfortable journeys suitable for local and outstation family trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "Urbania for Corporate Travel Pune",
    description: "Urbania for corporate travel Pune service offers professional premium transportation for business meetings, conferences, employee travel, industrial visits, and executive journeys. Spacious luxury interiors and smooth highway performance ensure comfortable travel experiences suitable for office teams and business passengers. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate Urbania reservations."
  },
  {
    name: "Urbania for Wedding Pune",
    description: "Urbania for wedding Pune service provides stylish premium transportation for bridal parties, family members, wedding guests, and marriage event travel requirements. Spacious seating and elegant interiors ensure smooth travel experiences suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding Urbania reservations."
  },
  {
    name: "Luxury Urbania Pune",
    description: "Luxury Urbania Pune service offers premium transportation for airport transfers, family vacations, corporate travel, sightseeing tours, and outstation journeys. Spacious luxury seating and modern interiors ensure pleasant travel experiences suitable for executive passengers and tourist groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania Hire Per KM Pune",
    description: "Urbania hire per km Pune service provides flexible and affordable premium transportation for local travel, airport transfers, sightseeing journeys, business trips, and outstation tours. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient per km Urbania reservations."
  }
],

tableData: [
  ["Pune to Mahabaleshwar Urbania On Rent", "Pune to Panchgani Urbania On Rent"],
  ["Pune to Tapola Urbania on Rent", "Pune to Wai Satara Urbania on Rent"],
  ["Pune to Kolhapur Urbania on Rent", "Pune to Jyotiba Urbania on Rent"],
  ["Pune to Kaas Plateau Urbania on Rent", "Pune to Lonavala Urbania on Rent"],
  ["Pune to Matheran Urbania on Rent", "Pune to Igatpuri Urbania on Rent"],
  ["Pune to Nashik Urbania on Rent", "Pune to Shirdi Urbania on Rent"],
  ["Pune to Bhimashankar Urbania on Rent", "Urbania for Outstation Pune"],
  ["Urbania for Family Trip Pune", "Urbania for Corporate Travel Pune"],
  ["Urbania for Wedding Pune", "Luxury Urbania Pune"],
  ["Urbania Hire Per KM Pune", "Pune to Mahabaleshwar Urbania On Rent"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mahabaleshwar Urbania On Rent",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Mahabaleshwar Urbania rental service with premium vehicles, experienced drivers, and smooth travel arrangements for family vacations, corporate trips, and group tours."
      },
      {
        WhyChooseheading: "Affordable Mahabaleshwar Urbania Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Mahabaleshwar Urbania rental packages with transparent pricing, flexible travel plans, and complete booking assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Urbania Booking Service from Pune",
        WhyChoosedescription: "Our Pune to Mahabaleshwar Urbania booking service operates 24 hours for weekend trips, sightseeing tours, holiday travel, family vacations, and corporate outings."
      },
      {
        WhyChooseheading: "Luxury & Fully AC Force Urbania Vehicles",
        WhyChoosedescription: "All Force Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and equipped with premium seating for comfortable hill station travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Mahabaleshwar Tours",
        WhyChoosedescription: "Aaradhya Travels offers one-day Mahabaleshwar sightseeing trips, weekend getaways, multi-day holiday tours, and customized outstation travel packages from Pune."
      },
      {
        WhyChooseheading: "Perfect for Family & Group Travel",
        WhyChoosedescription: "Force Urbania vehicles are ideal for family vacations, tourist groups, corporate teams, wedding travel, and comfortable outstation journeys to Mahabaleshwar."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Ghat Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Mahabaleshwar ghat roads and ensure safe driving, smooth travel, and comfortable journeys throughout the complete trip."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mahabaleshwar Urbania on rent?", answer: "Pune to Mahabaleshwar Urbania rental service provides premium group transportation for hill station trips, family vacations, and outstation tours." },
    { question: "Is Urbania booking available 24 hours from Pune to Mahabaleshwar?", answer: "Yes, Aaradhya Travels provides 24/7 Urbania rental service from Pune to Mahabaleshwar." },
    { question: "Can I book Urbania for one-day Mahabaleshwar trip?", answer: "Yes, customers can book one-day as well as multi-day Mahabaleshwar Urbania tour packages." },
    { question: "Do you provide customized Mahabaleshwar travel packages?", answer: "Yes, Aaradhya Travels provides customized Mahabaleshwar travel packages according to customer requirements." },
    { question: "Are all Force Urbania vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned and maintained for comfortable premium travel." },
    { question: "Can I book Pune to Mahabaleshwar Urbania online?", answer: "Yes, customers can easily book Urbania rental service online or through phone booking." },
    { question: "Do you provide Urbania for family and group tours?", answer: "Yes, Aaradhya Travels provides spacious Force Urbania vehicles suitable for family vacations, tourist groups, and corporate travel." },
    { question: "Are Pune to Mahabaleshwar Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Mahabaleshwar Urbania service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Hrishikesh Joshi",
    feedback:
      "The Pune to Mahabaleshwar trip with Aaradhya Travels in a Force Urbania was exceptionally comfortable. The premium seating and smooth ride made the hill journey very relaxing for the entire group.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Deshmukh",
    feedback:
      "Aaradhya Travels arranged a Force Urbania for our Pune to Mahabaleshwar outing, and the experience felt truly luxurious. The vehicle was spacious, well-maintained, and perfect for enjoying the scenic route without any discomfort.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Urbania On Rent",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-to-mahabaleshwar-urbania-on-rent.jpg",
  "description": "Book Pune to Mahabaleshwar Urbania on rent with Aaradhya Travels for premium group travel. Comfortable 13 and 17 seater Force Urbania available for Mahabaleshwar, Panchgani, Tapola, Wai, Satara, Kolhapur, Lonavala, Nashik, Matheran, and Igatpuri tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2478"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-to-mahabaleshwar-urbania-on-rent"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Mahabaleshwar Urbania On Rent | Luxury Travel Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Pune to Mahabaleshwar Urbania on rent with Aaradhya Travels. Premium 13 and 17 seater Urbania available for Mahabaleshwar, Panchgani, Tapola, Wai, Satara, Kolhapur, Lonavala, Nashik, Matheran, and Igatpuri outstation trips."
  />

  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Urbania On Rent, Pune to Panchgani Urbania On Rent, Pune to Tapola Urbania on rent, Pune to Wai Satara Urbania on rent, Pune to Kolhapur Urbania on rent, Pune to Jyotiba Urbania on rent, Pune to Kaas Plateau Urbania on rent, Pune to Lonavala Urbania on rent, Pune to Matheran Urbania on rent, Pune to Igatpuri Urbania on rent, Pune to Nashik"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwwarurbaniaonrent;